module.exports = __webpack_public_path__ + "static/media/gratis_ongkos_kirim.a1ef107b.png";